<template>
  <div>
    <div class="video-box">
      <video
        id="video"
        width="320"
        height="240"
        preload
        autoplay
        playsinline
        webkit-playsinline="true"
        loop
        muted
      ></video>
      <!-- <canvas id="canvas" width="320" height="240"></canvas> -->
    </div>
    <!-- <canvas id="screenshotCanvas" width="320" height="240"></canvas> -->
    <div class="switch-button">
        <van-button type="primary" @click="destroyed">关闭摄像头</van-button>
        <van-button type="primary" @click="init">开始识别</van-button>
    </div>
  </div>
</template>

<script>
require("tracking/build/tracking-min.js");
require("tracking/build/data/face-min.js");
export default {
  name: "special",
  components: {},
  computed: {},
  data() {
    return {
      trackerTask: null,
      mediaStreamTrack: null,
      video: null,
      screenshotCanvas: null,
      uploadLock: true, // 上传锁
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.init();
  },
  destroyed() {},
  methods: {
    init() {
      this.video = document.getElementById("video");
      // this.screenshotCanvas = document.getElementById("screenshotCanvas");

      // let canvas = document.getElementById("canvas");
      // let context = canvas.getContext("2d");

      // 固定写法
      let tracker = new window.tracking.ObjectTracker("face");
      tracker.setInitialScale(4);
      tracker.setStepSize(2);
      tracker.setEdgesDensity(0.1);
      window.tracking.track("#video", tracker, {
        camera: true,
      });

      // let _this = this;
      // tracker.on("track", function (event) {
      //   // 检测出人脸 绘画人脸位置
      //   context.clearRect(0, 0, canvas.width, canvas.height);
      //   event.data.forEach(function (rect) {
      //     context.strokeStyle = "#0764B7";
      //     context.strokeRect(rect.x, rect.y, rect.width, rect.height);

      //     // 上传图片
      //     _this.uploadLock && _this.screenshotAndUpload();
      //   });
      // });
    },
    destroyed() {
      if (!this.mediaStreamTrack) {
        return;
      }
      this.mediaStreamTrack.srcObject.getTracks()[0].stop();
      this.trackerTask.stop();
    },
    screenshotAndUpload() {
      // 上锁避免重复发送请求
      this.uploadLock = false;

      // 绘制当前帧图片转换为base64格式
      let canvas = this.screenshotCanvas;
      let video = this.video;
      let ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      let base64Img = canvas.toDataURL("image/jpeg");

      // 使用 base64Img 请求接口即可
      console.log("base64Img:", base64Img);

      // 请求接口成功以后打开锁
      // this.uploadLock = true;
    },
  },
};
</script>

<style lang="scss" scoped>
#screenshotCanvas {
  display: none;
}

.video-box {
  position: relative;
  margin-left: 30px;
  width: 320px;
  height: 240px;
}

.switch-button {
  margin-top: 30px;
  margin-left: 30px;
}
video,
canvas {
  position: absolute;
  top: 0;
  left: 0;
  border: #000000 5px solid;
}
</style>
